import { Card, CardColors, Link, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

export const ContactSupport = () => (
  <Card color={CardColors.LEVEL_1}>
    <Text variant={TypographyStyles.H1}>
      Have questions about this payroll?
    </Text>
    <br />
    <br />
    <Link href="/conversations" variant="secondary">
      Contact Support
    </Link>
  </Card>
)
